import React, { useState } from 'react';

type Props = { imageSrc?: string };

const MockWindow: React.FC<Props> = ({ imageSrc }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className="relative w-full max-w-[40rem] xl:max-w-[48rem] 2xl:max-w-[56rem] mx-auto drop-shadow-mock">
      <div className="shadow-2xl ring-1 ring-black/5 rounded-2xl overflow-hidden bg-white">
        {/* Window top bar */}
        <div className="bg-gray-100 border-b border-gray-200 rounded-t-2xl px-4 py-3 flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full bg-red-400"></span>
          <span className="h-2.5 w-2.5 rounded-full bg-yellow-400"></span>
          <span className="h-2.5 w-2.5 rounded-full bg-green-400"></span>
          <div className="h-5 flex-1 rounded-full bg-white/70 ring-1 ring-gray-200" />
        </div>

        <div className="relative">
          {/* Fallback skeleton visible until image loads or on error */}
          {!loaded && (
            <div className="bg-white">
              <div className="grid grid-cols-1 lg:grid-cols-[12rem_1fr]">
                {/* Sidebar */}
                <aside className="hidden lg:block bg-sedra text-white/95 p-4 space-y-2">
                  {['Dashboard','Invoices','Customers','Rates','Reports','Settings'].map((t, i) => (
                    <div
                      key={t}
                      className={
                        'flex items-center gap-2 rounded-lg px-3 py-2 text-sm/6 ' +
                        (i === 0 ? 'bg-white/15 ring-1 ring-white/10' : 'hover:bg-white/10')
                      }
                    >
                      <div className="h-4 w-4 rounded bg-white/70" aria-hidden />
                      <span>{t}</span>
                    </div>
                  ))}
                </aside>

                {/* Main content */}
                <section className="p-5 lg:p-6 bg-white">
                  <h2 className="text-sm font-semibold text-gray-700">Dashboard</h2>

                  {/* Metrics row */}
                  <div className="mt-3 grid grid-cols-3 gap-3">
                    {[
                      { label: 'Funding', value: '$12,450' },
                      { label: 'Paid', value: '$7,200' },
                      { label: 'Overdue', value: '$1,160' }
                    ].map(({ label, value }) => (
                      <div key={label} className="rounded-xl border border-gray-200 bg-white p-4 elev-1">
                        <div className="text-xl font-bold text-gray-900">{value}</div>
                        <div className="text-xs text-gray-500">{label}</div>
                      </div>
                    ))}
                  </div>

                  {/* Quick actions */}
                  <div className="mt-4 grid grid-cols-3 gap-3">
                    {['Send invoices','Track payments','Save time'].map((t) => (
                      <div key={t} className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-center text-sm font-medium text-gray-700">
                        {t}
                      </div>
                    ))}
                  </div>

                  {/* List */}
                  <div className="mt-5 space-y-2">
                    {[1,2,3].map((i) => (
                      <div key={i} className="flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 elev-1">
                        <div className="h-2.5 w-24 rounded bg-gray-200" />
                        <div className="h-2.5 w-40 rounded bg-gray-100" />
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            </div>
          )}

          {imageSrc && !error && (
            <img
              src={imageSrc}
              alt="Sedra Invoices dashboard preview"
              loading="eager"
              className={loaded ? 'block w-full h-auto rounded-b-2xl opacity-100 transition-opacity' : 'block w-full h-auto rounded-b-2xl opacity-0 transition-opacity'}
              onLoad={() => setLoaded(true)}
              onError={() => setError(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MockWindow; 